import { createContext } from "react";
/**
 * Context for other components
 */
export const OtherComponentContext = createContext({});
OtherComponentContext.displayName = "OtherComponentContext";
//# sourceMappingURL=OtherComponentContext.js.map